<template>
  <section
    class="c-payment c-form c-form--ghost bg-white p-3 p-lg-4"
  >
    <b-skeleton-wrapper :loading="userLoading" class="mb-4">
      <template #loading>
        <b-skeleton
          no-aspect
          width="70%"
          height="100%"
          animation="fade"
          class="light mb-4"
        ></b-skeleton>

        <b-card>
          <div class="row">
            <div class="col col-12 col-md-6 mb-3">
              <b-skeleton
                no-aspect
                width="50%"
                height="20px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
              <b-skeleton
                no-aspect
                type="input"
                height="50px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
            </div>
            <div class="col col-12 col-md-6 mb-3">
              <b-skeleton
                no-aspect
                width="50%"
                height="20px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
              <b-skeleton
                no-aspect
                type="input"
                height="50px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
            </div>
            <div class="col col-12 col-md-6 mb-3 mb-md-0">
              <b-skeleton
                no-aspect
                width="50%"
                height="20px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
              <b-skeleton
                no-aspect
                type="input"
                height="50px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
            </div>
            <div class="col col-12 col-md-6 mb-3 mb-md-0">
              <b-skeleton
                no-aspect
                width="50%"
                height="20px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
              <b-skeleton
                no-aspect
                type="input"
                height="50px"
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
            </div>
          </div>
        </b-card>
      </template>

      <div v-if="(userData && userData.id) || !stepAuthEnabled">
        <h2 class="fs-21 w-bold darks mb-3 d-flex
          justify-content-between align-items-md-center">
          <span>Elige un medio de pago</span>
          <Countries
            v-if="country.codeOrigin === 'pe'"
            class="ms-2"
          >
          </Countries>
        </h2>

        <b-tabs v-model="methodIndex" class="c-tabs c-tabs--checkout mb-4">
          <b-tab>
            <template #title>
              <div class="d-flex align-items-center justify-content-center h-100">
                <img
                  class="c-icon of--contain"
                  src="@/assets/images/icons/checkout/card.svg"
                  alt="Visa" />
              </div>
            </template>
            <section>
              <div
                v-if="isTrialPlan && !userData.id"
                class="c-card-alert c-card-alert--error p-3 mb-4 text-center">
                <span>
                  Para realizar esta compra necesitas primero
                  <a
                    :href="`${arcux.site}/ingresar?back_url=${backUrl}`"
                    class="w-bold"
                    style="color: #e10000;">INGRESAR</a>
                  a tu cuenta o
                  <a
                    :href="`${arcux.site}/registrarse?back_url=${backUrl}`"
                    class="w-bold"
                    style="color: #e10000;">CREAR UNA NUEVA CUENTA.</a>
                </span>
              </div>
              <div
                v-if="card.error.active"
                class="c-card-alert c-card-alert--error p-3 mb-4 text-center"
              >
                {{ card.error.message }}
              </div>
              <h3 class="fs-18 darks w-bold mb-3">Datos personales</h3>
              <div class="row">
                <div class="col col-12 col-md-6 mb-4">
                  <p class="c-form__label mb-1">Nombre completo</p>
                  <input
                    v-model="user.fullName.value"
                    @keypress="isRightField($event, 'letter')"
                    @keydown.enter.tab="user.fullName.tested = true"
                    type="text"
                    class="c-form__input w-100"
                    tabindex="1"
                    placeholder="ej. Arcuxito Perez"
                  />
                  <span v-if="isWrongField(user.fullName)" class="c-form__error">
                    {{
                      (!user.fullName.value.length)
                        ? 'Nombre incorrecto'
                        : 'Ingresa tus nombres completos'
                    }}
                  </span>
                </div>
                <div class="col col-12 col-md-6 mb-4">
                  <p class="c-form__label mb-1">Correo electrónico</p>
                  <input
                    v-model="user.email.value"
                    @keydown.enter.tab="user.email.tested = true"
                    :disabled="userData.id"
                    type="text"
                    data-culqi="card[email]"
                    class="c-form__input w-100"
                    tabindex="2"
                    placeholder="ej. arcuxito@ejemplo.com"
                  />
                  <span v-if="isWrongField(user.email)" class="c-form__error">
                    Correo incorrecto
                  </span>
                </div>
                <div class="col col-12 col-12 mb-4">
                  <p class="c-form__label mb-1">Número de tarjeta</p>
                  <input
                    v-model="card.number.value"
                    @keypress="formatCreditCard($event, 'number');"
                    @keydown.enter.tab="card.number.tested = true"
                    type="text"
                    minlength="11"
                    maxlength="24"
                    data-culqi="card[number]"
                    class="c-form__input w-100"
                    tabindex="3"
                    :disabled="pay.method.card.isLoading"
                    placeholder="XXXX XXXX XXXX XXXX"
                  />
                  <span
                    v-if="isWrongField(card.number, 'multiple', 'card')"
                    class="c-form__error"
                  >
                    Tarjeta incorrecta
                  </span>
                </div>
                <div class="col col-12 col-md-6 col-lg-12 col-xl-6 mb-4 mb-xl-0">
                  <p class="c-form__label mb-1">Fecha de expiración</p>
                  <div class="row">
                    <div class="col col-6">
                      <select
                        v-model="card.month.value"
                        @keydown.enter.tab="card.month.tested = true"
                        class="c-form__select w-100" tabindex="4">
                        <option value="" disabled selected>Mes</option>
                        <option
                          v-for="month of months"
                          :key="month.id"
                          :value="month"
                        >
                          {{month}}
                        </option>
                      </select>
                    </div>
                    <div class="col col-6">
                      <select
                        v-model="card.year.value"
                        @keydown.enter.tab="card.year.tested = true"
                        class="c-form__select w-100" tabindex="5"
                      >
                        <option value="" disabled selected>Año</option>
                        <option
                          v-for="year of years"
                          :key="year.id"
                          :value="year"
                        >
                          {{year}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <span
                    v-if="isWrongField(card.month, 'multiple', 'card')
                      || isWrongField(card.year, 'multiple', 'card')"
                    class="c-form__error"
                  >
                    Fecha incorrecta
                  </span>
                </div>
                <input
                  type="hidden"
                  v-model="card.month.value"
                  tabindex="-1"
                  data-culqi="card[exp_month]" />
                <input
                  type="hidden"
                  v-model="card.year.value"
                  tabindex="-1"
                  data-culqi="card[exp_year]" />
                <div class="col col-12 col-md-6 col-lg-12
                  col-xl-6 mb-3 mb-md-4 mb-xl-0">
                  <p class="c-form__label mb-1">CVV</p>
                  <div class="c-form__input-toggle">
                    <button class="c-initator c-tooltip-toggle
                      d-flex align-items-center">
                      <i class="iconf-help-circled d-flex align-items-center fs-18"></i>
                    </button>
                    <input
                      v-model="card.cvv.value"
                      @keypress="isRightField($event, 'number')"
                      @keydown.enter.tab="card.cvv.tested = true"
                      type="text"
                      maxlength="4"
                      data-culqi="card[cvv]"
                      class="c-form__input w-100"
                      tabindex="6"
                      :disabled="pay.method.card.isLoading"
                      placeholder="XXX"
                    />
                  </div>
                  <span
                    v-if="isWrongField(card.cvv, 'multiple', 'card')"
                    class="c-form__error"
                  >
                    Código incorrecto
                  </span>
                </div>
              </div>
            </section>
          </b-tab>
          <b-tab v-if="!isTrialPlan">
            <template #title>
              <div class="d-flex align-items-center justify-content-center h-100">
                <img
                  class="c-icon of--contain"
                  src="@/assets/images/icons/checkout/paypal.svg"
                  alt="PayPal" />
              </div>
            </template>
            <section>
              <div
                v-if="paypalAlert"
                class="c-card-alert c-card-alert--success p-3 mb-4 text-center"
              >
                {{ paypalAlert }}
              </div>
              <h3 class="fs-18 darks w-bold mb-3">
                Para seguir con tu compra deberás inicar sesión en PayPal
              </h3>
              <p class="mb-0">
                Después del pago, permanece atento a tu email para recibir los
                datos de acceso al producto (verifica también la casilla de SPAM)
              </p>
            </section>
          </b-tab>
          <b-tab v-if="!isTrialPlan">
            <template #title>
              <p
                v-if="country.code == 'pe'"
                class="mb-0 d-flex align-items-center justify-content-center">
                <img
                  class="c-icon c-icon--cash of--contain"
                  src="@/assets/images/icons/checkout/pagoefectivo.png"
                  alt="Pago Efectivo" />
              </p>
              <p
                v-else
                class="mb-0 d-flex flex-column flex-md-row
                  align-items-center justify-content-center">
                <img
                  class="c-icon of--contain"
                  src="@/assets/images/icons/checkout/cash.svg"
                  alt="Efectivo" />
                <span class="ms-2 mt-1 mt-md-0">Efectivo</span>
              </p>
            </template>
            <section>
              <CashMethod
                v-if="arcux"
                element="body"
                :arcux="arcux"
                :product="product"
                :user="user"
                :coupon="coupon"
                :price="productPaidPrice"
                :isRightField="isRightField"
                :isWrongField="isWrongField"
                :backUrl="backUrl">
              </CashMethod>
            </section>
          </b-tab>
        </b-tabs>

        <div class="mb-4">
          <div v-show="paymentMethod == 'visa'" key="pay-card">
            <label v-if="isTrialPlan" class="c-form__checkbox-inline mb-2">
              <input v-model="card.store" id="terms" type="checkbox" class="d-none" />
              <div class="c-square">
                <span></span>
              </div>
              <span>
                Entiendo que se guardará mi tarjeta y se me cobrará
                <span class="w-bold">{{ productFinalPrice }} por 14 días,</span>
                seguido de <span class="w-bold">US$ 99.00</span>
                cada año hasta que cancele mi suscripción.
                (Puedes cancelar tu suscripción en cualquier momento)
              </span>
            </label>
            <button
              @click="handleCheckoutWithCard"
              :disabled="pay.method.card.isLoading
                || (isTrialPlan && !card.store) || (isTrialPlan && !userData.id)"
              class="c-button c-button--primary w-100"
              :class="{loading : pay.method.card.isLoading}">
              {{
                (pay.method.card.isLoading) ? 'Validando...' : 'Pagar ahora'
              }}
              <img
                class="c-button__spinner"
                src="@/assets/images/animations/spinner-white.png"
                alt="loading"
              />
            </button>
          </div>
          <div v-show="paymentMethod == 'paypal'" key="pay-paypal">
            <div id="paypal-button-container"></div>
          </div>

          <CashMethod
            v-show="paymentMethod == 'cash'"
            key="pay-cash"
            element="button"
            :arcux="arcux"
            :product="product"
            :productPlan="productPlan"
            :user="user"
            :coupon="coupon"
            :price="productPaidPrice">
          </CashMethod>
        </div>
        <label class="c-form__checkbox-inline">
          <input v-model="user.terms" id="terms" type="checkbox" class="d-none" />
          <div class="c-square">
            <span></span>
          </div>
          <span>
            Acepto las
            <a
              :href="arcux.project.terms"
              class="c-link"
              target="_blank"
            >
              Condiciones, Términos
            </a>
            y
            <a
              :href="arcux.project.politics"
              class="c-link"
              target="_blank"
            >
              Políticas
            </a>
            de Arcux
          </span>
        </label>
        <p
          v-if="isWrongField(user.terms, 'single')"
          class="c-form__error mb-0 mt-3"
        >
          Debe aceptar las condiciones, términos y politicas
        </p>
      </div>
      <div v-else>
        <h2 class="fs-21 w-bold darks mb-3">
          Registrate o inicia sesión
        </h2>
        <p class="w-medium mb-3">
          Gracias a tu registro/inicio de sesión se activara
          automáticamente tu curso comprado
        </p>
        <div class="mb-4">
          <div class="row">
            <div class="col col-6">
              <a
                :href="signInLink"
                class="c-button c-button--primary d-block text-center h-100">
                Iniciar sesión
              </a>
            </div>
            <div class="col col-6">
              <a
                :href="signUpLink"
                class="c-button c-button--primary-ghost d-block text-center h-100">
                Registrarme
              </a>
            </div>
          </div>
        </div>

        <div class="mb-2">
          <div class="c-hr bg-color-gray"></div>
        </div>

        <p class="mb-0 w-medium">
          Comprar como anonimo (activarlo en otra cuenta),
          <button @click="stepAuthEnabled = false" class="c-link c-link--primary">
            omitir este paso
          </button>
        </p>
      </div>
    </b-skeleton-wrapper>
  </section>
</template>

<script>
/* eslint-disable */
import tippy from 'tippy.js';
import { Icon } from '@iconify/vue2';

import PaymentDetails from '../../components/checkout/PaymentDetails.vue';
import Countries from '../../components/checkout/Countries.vue';
import CashMethod from '../../components/checkout/methods/Cash.vue';

import { validateText, validateSelect } from '../../libs/forms';

import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      arcux: { ...window.arcux},

      device: '',
      methodIndex: 0,

      stepAuthEnabled: true,

      user: {
        try: false,
        fullName: {
          value: '',
          isValid: false,
          tested: false,
          pattern: '^([a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð,._\'-]+){2,}( ){1}([a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,._\'-]{2,})$',
        },
        email: {
          value: '',
          isValid: false,
          tested: false,
          pattern: '^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$',
        },
        phone:  {
          value: '',
          tested: false,
          isValid: false,
        },
        terms: true,
      },

      card: {
        try: false,
        store: false,
        number: {
          value: '',
          isValid: false,
          tested: false,
          pattern: '^[0-9 ]{14,24}',
        },
        month: {
          value: '',
          isValid: false,
          tested: false,
        },
        year: {
          value: '',
          isValid: false,
          tested: false,
        },
        cvv: {
          value: '',
          isValid: false,
          tested: false,
          pattern: '^[0-9]{3,4}',
        },
        error: {
          active: false,
          message: '',
        },
      },

      pay: {
        type: 'registered',
        isLoadingRegister: false,
        isLoadingLogin: false,
        success: false,
        purchase_code: '',
        method: {
          card: {
            isLoading: false,
          },
          paypal: {
            alert: '',
            isLoading: false,
          },
          cash: {
            isLoading: false,
          },
        },
        order: 0,
      },

      user_temp: '',
    }
  },
  components: {
    OrderSummary: () => import(/* webpackChunkName: "order-summary" */'../../components/checkout/OrderSummary.vue'),
    PaymentDetails,
    Countries,
    CashMethod,
    Icon,
  },
  computed: {
    ...mapState({
      country: (state) => state.checkout.country,
      paymentMethod: (state) => state.checkout.paymentMethod,
      product: (state) => state.checkout.product,
      price: (state) => state.checkout.price,
      coupon: (state) => state.checkout.coupon,
      userData: (state) => state.user.userData,
      userLoading: (state) => state.user.userLoading,
    }),

    backUrl() {
      return window.location.href;
    },

    months() {
      return Array.from({length: 12}, (x, i) => {
        const m = i + 1;

        return (m < 10) ? `0${m}` : m;
      });
    },
    years() {
      return Array.from({length: 21}, (x, i) => i + (new Date().getFullYear()) );
    },
    cardError() {
      return this.card.error.message.replace('Contáctanos para más detalle', `<a href="${this.whatsappLink}" class="c-link"><span class="alerts">Contáctanos para más detalle</span></a>`);
    },
    paypalAlert() {
      if (this.pay.method.paypal.isLoading) {
        return 'Procesando compra...';

      } else if (this.pay.method.paypal.alert) {
        return this.pay.method.paypal.alert;

      } else {
        return false;

      }
    },

    productPlan() {
      return (this.$route.query.plan) ? this.$route.query.plan : '';
    },
    productFinalPrice() {
      return (this.price.current && this.price.current.name)
        ? `${this.price.current.amount.currency.symbol_full}${Number(this.price.current.amount.final).toLocaleString('en')}`
        : '0.00';
    },
    productPaidPrice() {
      const coupon = (this.coupon.current) ? Number(this.coupon.current.amount) : 0;

      return (this.price.current && this.price.current.name)
        ? `${this.price.current.amount.currency.symbol_full}${(Number(this.price.current.amount.final) - coupon).toLocaleString('en')}`
        : '0.00';
    },

    isTrialPlan() {
      return (this.$route.query.plan.search('trial') >= 0 || this.$route.query.plan.search('gratis') >= 0)
        ? true
        : false ;
    },

    signInLink() {
      return `${this.arcux.site}/panel/ingresar?back_url=${this.backUrl}`;
    },
    signUpLink() {
      return `${this.arcux.site}/panel/registrarse?back_url=${this.backUrl}`;
    },
  },
  watch: {
    'user.fullName.value': function() {
      this.user.fullName.isValid  = this.validateText(this.user.fullName);
    },
    'user.email.value': function() {
      this.user.email.isValid = this.validateText(this.user.email);
    },
    'card.number.value': function() {
      this.card.number.isValid = this.validateText(this.card.number);
    },
    'card.month.value': function() {
      this.validateSelect(this.card.month);
    },
    'card.year.value': function() {
      this.validateSelect(this.card.year);
    },
    'card.cvv.value': function() {
      this.card.cvv.isValid = this.validateText(this.card.cvv);
    },

    'methodIndex': function(index) {
      let method = 'visa';

      if (index === 0) {
        method = 'visa';
      } else if (index === 1) {
        method = 'paypal';
      } else  if (index === 2){
        method = 'cash';
      }

      this.setPaymentMethod(method);
    },

    'userData': function() {
      if (this.userData && this.userData.id) this.initUser();
    },

    stepAuthEnabled(value) {
      window.setTimeout(() => {
        this.handleCheckoutWithPaypal();
      }, 100)
    },
  },
  mounted() {
    this.loadScripts();
    this.loadGlobalScripts();

    this.initTooltips();

    window.setTimeout(() => {
      window.Culqi.publicKey = process.env.VUE_APP_PROJECT_CULQI_TOKEN_PUBLIC;
      window.Culqi.init();

      this.handleCheckoutWithPaypal();
    }, 2000)

    if (!(this.userData && this.userData.id)) {
      if (!window.sessionStorage.getItem('user_temp')) {
        window.sessionStorage.setItem('user_temp', new Date().getTime());
      }

      this.user_temp = window.sessionStorage.getItem('user_temp');
    }

    window.fbq('track', 'InitiateCheckout');

    if (this.userData && this.userData.id) this.initUser();
  },
  methods: {
    ...mapActions(['updatePaymentMethod']),
    validateText,
    validateSelect,

    isWrongField: function(field, type = 'multiple', context = 'user') {
      return (this[context].try || field.tested) && ((type == 'multiple') ? !field.isValid : !field);
    },
    isRightField: function(e, type) {
      const char = String.fromCharCode(e.keyCode);

      switch (type) {
        case 'letter': {
            const length = this.user.fullName.value.length;

            if ( (!length && char == ' ') || (length && this.user.fullName.value[ length - 1] == ' ' && char == ' ') ) e.preventDefault();

            if( /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,._\'-]+$/.test(char) ) return true;
            else e.preventDefault();
          }
          break;

        case 'number': {
            if( /^[0-9]+$/.test(char) ) return true;
            else e.preventDefault();
          }
          break;
      }
    },
    formatCreditCard: function (e, type) {
      if ( this.isRightField(e, type) )
        this.card.number.value = this.card.number.value
          .trim()
          .replace(/[^a-z0-9]+/gi, '')
          .replace(/(.{4})/g, '$1 ');
    },
    verifyEnroll: function() {
      const url = `${this.arcux.site}/api/v1/courses/${this.arcux.course}/students/${(this.userData && this.userData.id)}/`;

      fetch(url)
      .then(res => {
        return res.json();
      }).then(data => {
        return data;
      });
    },
    initTooltips: function() {
      window.setTimeout(()=>{
        tippy('.c-tooltip-toggle', {
          content(reference) {
            return `
            <div class="c-tooltip c-tooltip--tiny p-2">
              <div class="row mb-3">
                <div class="col col-8">
                  <p class="mb-0 w-medium">Visa, Master y Otros: 3 digitos en el reverso de la tarjeta</p>
                </div>
                <div class="col col-4">
                  <img src="${ require('@/assets/images/checkout/cvv/visa.svg') }"></img>
                </div>
              </div>
              <div class="row">
                <div class="col col-8">
                  <p class="mb-0 w-medium">American Express: 4 dígitos en el anverso de la tarjeta</p>
                </div>
                <div class="col col-4">
                  <img src="${ require('@/assets/images/checkout/cvv/mastercard.svg') }"></img>
                </div>
              </div>
            </div>`;
          },
          allowHTML: true,
          theme: 'arcux-dark',
          animation: 'scale',
          inertia: true,
          hideOnClick: true,
          trigger: 'click',
        });
      }, 2000)
    },
    setPaymentMethod: function(method) {
      this.updatePaymentMethod(method);
    },

    sendMetricsEvent: function(name, product, userType) {
      this.$ga.event(product, name, userType, -1);
    },

    createCulqiToken: async function() {
      Culqi.createToken();

      if (Culqi.token && Culqi.token.object === 'token') {
        return Culqi.token.id;
      } else {
        if (Culqi.error !== undefined) {
          throw new Error(Culqi.error);
        } else {
          await new Promise(resolve => setTimeout(resolve, 3000));

          return this.createCulqiToken();
        }
      }
    },
    handleCheckoutWithCard: async function() {
      this.card.try = this.user.try = true;

      if (
        this.card.number.isValid &&
        this.card.month.isValid &&
        this.card.year.isValid &&
        this.card.cvv.isValid &&
        this.user.fullName.isValid &&
        this.user.email.isValid &&
        this.user.terms
      ) {
        this.pay.method.card.isLoading = true;

        if (!(this.userData && this.userData.id) && !this.user.fullName.isValid && !this.user.email.isValid) {
          return;
        }

        try {
          await this.createCulqiToken();

          this.card.error.active  = false;
          this.card.error.message = '';

          const token = Culqi.token.id;

          this.sendMetricsEvent(
            `Click Buy Button ${(this.product.type === 'course' ? 'Premium' : 'Subscription')}`,
            this.product.data.title,
            (this.userData && this.userData.id) ? 'REGISTERED USER' : 'NON REGISTERED USER'
          );

          const url = `${ this.arcux.site }/api/v1/checkout/products/${ this.product.data.id }`;

          let params = {
            token,
            plan: this.productPlan,
            payment_method: 'card',
            payment_gateway: 'culqi',
            country_code: this.country.codeOrigin,
            selected_country: (this.country.code == 'world' || this.country.code != 'pe') ? 'us' : 'pe',
            ... (this.pay.order) && { order: this.pay.order },
            metadata: Culqi.token,
          };

          if (this.isTrialPlan) {
            params.store_card = true;
          }

          if (this.coupon.code.isValid) {
            params.coupon = this.coupon.code.value;
          }

          const fullName = this.user.fullName.value.trim().replace(/\s+/g, ' ');

          params.first_name = fullName.substr(0, fullName.indexOf(' '));
          params.last_name  = fullName.substr(fullName.indexOf(' ') + 1);
          params.email      = this.user.email.value;

          if (!(this.userData && this.userData.id)) params.user_tmp = this.user_temp;

          fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              ... (this.userData && this.userData.id) && { Authorization: `Bearer ${window.arcux.token}` },
            },
            body: JSON.stringify(params),
          })
            .then(res => {
              return res.json();
            })
            .then(data => {
              if (!data.status) {
                throw data;
              }

              if ((this.userData && this.userData.id)) {
                this.$router.push({
                  path: `/checkout/order-received/${data.order}`,
                  query: { success: 'ok' },
                });
              } else {
                this.$router.push({
                  path: `/checkout/order-received/${data.order}`,
                  query: { pc: data.purchase_code, success: 'ok', user: this.user.fullName.value },
                });
              }
            })
            .catch(err => {
              this.card.error.active  = true;
              this.card.error.message = err.message;
            }).finally(() => {
              this.pay.method.card.isLoading = false;
            });
        } catch (err) {
          this.pay.method.card.isLoading  = false;

          if (err) {
            this.card.error.active = true;
            this.card.error.message = err.user_message
              ? err.user_message
              : 'No se logró continuar con la compra, vuelva a intentarlo por favor.';
          }
        }
      }
    },
    handleCheckoutWithPaypal: function() {
      paypal.Buttons({
        style: {
          shape: 'rect',
          color: 'white',
          layout: 'horizontal',
          label: 'pay',
          size: 'responsive',
        },
        env: process.env.VUE_APP_PROJECT_PAYPAL_ENVIRONMENT,
        onInit: (data, actions) => {
          window.document.querySelector('#terms')
            .addEventListener('change', function(event) {
              if (event.target.checked) {
                actions.enable();
              } else {
                actions.disable();
              }
            });
        },
        onClick: () => {
          this.sendMetricsEvent(
            this.product.type === 'course' ? 'Click Buy Button Premium' : 'Click Buy Button Subscription',
            this.product.data.title,
            (this.userData && this.userData.id) ? 'REGISTERED USER' : 'NON REGISTERED USER'
          );
        },
        createOrder: () => {
          const url = `${ this.arcux.site }/api/v1/checkout/products/${ this.product.data.id }`;

          this.pay.method.paypal.isLoading = true;

          let params = {
            plan: this.productPlan,
            payment_method: 'paypal',
            payment_gateway: 'paypal',
            country_code: this.country.codeOrigin,
            selected_country: (this.country.code == 'world' || this.country.code != 'pe') ? 'us' : 'pe',
            ... (this.pay.order) && { order: this.pay.order },
          }

          if (this.coupon.code.isValid) {
            params.coupon = this.coupon.code.value;
          }

          if (!(this.userData && this.userData.id)) {
            params.user_tmp = this.user_temp;
          }

          return fetch(url, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: {
              'content-type': 'application/json',
              ... (this.userData && this.userData.id) && { Authorization: `Bearer ${window.arcux.token}` },
            },
          }).then((res) => {
            return res.json();
          }).then((data) => {
            this.pay.order = data.order;

            return data.payment;
          });
        },
        onApprove: (data, actions) => {
          return actions.order.capture().then((details) => {
            const url = `${ this.arcux.site }/api/v1/checkout/products/${ this.product.data.id }/pypl`;

            let params = {
              plan: this.productPlan,
              country_code: this.country.codeOrigin,
              selected_country: (this.country.code == 'world' || this.country.code != 'pe') ? 'us' : 'pe',
              order: this.pay.order,
              action: 'success',
            };

            if (this.coupon.code.isValid) {
              params.coupon = this.coupon.code.value;
            }

            if (!(this.userData && this.userData.id)) {
              this.user.fullName.value = details.payer.name.given_name + ' ' + details.payer.name.surname;

              params.user_tmp     = this.user_temp;
              params.country_code = details.payer.address.country_code;
            }

            params.email        = this.user.email.value = details.payer.email_address;
            params.first_name   = details.payer.name.given_name;
            params.last_name    = details.payer.name.surname;

            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                ... (this.userData && this.userData.id) && { Authorization: `Bearer ${window.arcux.token}` },
              },
              body: JSON.stringify(params),
            })
            .then(res => {
              return res.json();
            })
            .then(data => {
              if (!data.status) {
                throw data;
              }

              this.pay.method.paypal.isLoading = false;

              if ((this.userData && this.userData.id)) {
                this.$router.push({
                  path: `/checkout/order-received/${data.order}`,
                  query: { success: 'ok' },
                });
              } else {
                this.$router.push({
                  path: `/checkout/order-received/${data.order}`,
                  query: {
                    pc: data.purchase_code,
                    success: 'ok',
                    user_firstname: params.first_name,
                    user_lastname: params.last_name,
                  },
                });
              }
            })
          })
        },
        onCancel: () => {
          const url = `${ this.arcux.site }/api/v1/checkout/products/${ this.product.data.id }/pypl`;

          let params = {
            plan: this.productPlan,
            country_code: this.country.codeOrigin,
            selected_country: this.country.code,
            order: this.pay.order,
            action: 'cancelled',
          }

          this.pay.method.paypal.isLoading = false;
          this.pay.method.paypal.alert = 'Cancelando orden...';

          return fetch(url, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: {
              'content-type': 'application/json',
              ... (this.userData && this.userData.id) && { Authorization: `Bearer ${window.arcux.token}` },
            },
          }).then((res) => {
            return res.json();
          }).then((response) => {
            if (response.status) {
              this.pay.order = 0;
              this.pay.method.paypal.alert = 'Orden cancelada exitosamente';

              window.setTimeout(() => {
                this.pay.method.paypal.alert = '';
              }, 1000);
            }
          });
        },
      }).render('#paypal-button-container');
    },

    initUser: function() {
      this.user.fullName.value  = `${ this.userData.first_name } ${ this.userData.last_name }`;
      this.user.email.value     = this.userData.email;
    },

    loadScripts() {
      let culqiScript = document.createElement('script');
      let payPalScript = document.createElement('script');
      let manyChatScript = document.createElement('script');
      let manyChatCDNScript = document.createElement('script');

      culqiScript.setAttribute('src', 'https://checkout.culqi.com/v2');
      payPalScript.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${process.env.VUE_APP_PROJECT_PAYPAL_TOKEN_PUBLIC}`);

      manyChatScript.setAttribute('src', '//widget.manychat.com/769862579846062.js');
      manyChatCDNScript.setAttribute('src', 'https://mccdn.me/assets/js/widget.js');

      document.head.appendChild(culqiScript);
      document.head.appendChild(payPalScript);
      document.head.appendChild(manyChatScript);
      document.head.appendChild(manyChatCDNScript);
    },
  },
}
</script>
